import React from 'react';
import { motion } from 'framer-motion';

const Toggle = ({ isOn, onToggle, label }) => {
  return (
    <div className="flex items-center justify-between w-full max-w-md p-2">
      <span className="text-sm text-slate-700 dark:text-slate-300">{label}</span>
      <div
        className={`relative w-12 h-6 rounded-full cursor-pointer transition-colors duration-200 ${
          isOn ? 'bg-blue-500/80' : 'bg-slate-200 dark:bg-slate-700'
        }`}
        onClick={onToggle}
      >
        <motion.div
          className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-sm"
          animate={{
            x: isOn ? 24 : 0,
          }}
          transition={{
            type: "spring",
            stiffness: 700,
            damping: 30
          }}
        />
      </div>
    </div>
  );
};

export default Toggle; 